import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { Provider } from 'jotai';
import OlMap from '@/components/OlMap';
import theme from './theme';

export default function App() {
  return (
    <Provider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <OlMap />
      </ThemeProvider>
    </Provider>
  );
}
